export const categories = [
  { slug: 'entreprise', name: 'Entreprise', parent: null },
  { slug: 'commerce', name: 'Commerce', parent: null },
  { slug: 'gestion-projet', name: 'Gestion de projet', parent: null },
  { slug: 'technique', name: 'Technique', parent: null },
  { slug: 'qualité', name: 'Qualité', parent: null },
  { slug: 'ressources-humaines', name: 'Ressources humaines', parent: null },
  { slug: 'référentiels', name: 'Référentiels', parent: null },
  { slug: 'doe', name: 'DOE', parent: 'gestion-projet' },
  { slug: 'cfo', name: 'CFO', parent: 'technique' },
  { slug: 'cfa', name: 'CFA', parent: 'technique' },
];

export const articleTypes = [
  'Procédure',
  'Mode opératoire',
  'Guide',
  'Checklist',
  'Modèle',
  'Fiche technique',
  'Retour d\'expérience',
  'FAQ',
  'Référentiel',
  'Décision',
];

export const statuses = ['Brouillon', 'A valider', 'Publié', 'A réviser', 'Archivé'];

export const adminSections = [
  { key: '', label: 'Articles', status: '' },
  { key: 'drafts', label: 'Brouillons', status: 'Brouillon' },
  { key: 'review', label: 'A valider', status: 'A valider' },
  { key: 'revise', label: 'A réviser', status: 'A réviser' },
  { key: 'archived', label: 'Archives', status: 'Archivé' },
];

export const initialArticles = [];

export const slugify = (value) => String(value || '')
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, '-')
  .replace(/^-+|-+$/g, '') || 'article';

export const getCategoryName = (slug) => categories.find((category) => category.slug === slug)?.name || slug || '-';

export const isCategoryActive = (category) => category.isActive === undefined
  || category.isActive === true
  || category.isActive === 1
  || category.isActive === '1';

export const getRouteParts = (pathname) => pathname
  .replace(/^\/wiki\/?/i, '')
  .split('/')
  .filter(Boolean);

export const matchArticle = (article, needle) => [
  article.title,
  article.category,
  article.type,
  article.owner,
  article.status,
  article.tags,
  article.summary,
  article.content,
  article.plainText,
  article.renderedHtml,
  typeof article.contentJson === 'string' ? article.contentJson : JSON.stringify(article.contentJson || ''),
].some((value) => String(value || '').toLowerCase().includes(needle));

export const buildToc = (content = '') => String(content)
  .split('\n')
  .map((line) => line.trim())
  .filter((line) => line && !/^\d+\./.test(line) && line.length <= 54)
  .slice(0, 6);

export const parseIdList = (value = '') => String(value)
  .split(',')
  .map((item) => Number.parseInt(item.trim(), 10))
  .filter((item) => Number.isInteger(item) && item > 0);

export const parseAttachmentText = (value = '') => String(value)
  .split('\n')
  .map((line) => line.trim())
  .filter(Boolean)
  .map((line) => {
    const [label, documentId] = line.split('|').map((part) => part.trim());
    return {
      label,
      documentId: documentId ? Number.parseInt(documentId, 10) : null,
    };
  });

export const formatAttachmentText = (attachments = []) => attachments
  .map((attachment) => {
    if (typeof attachment === 'string') {
      return attachment;
    }

    return [attachment.label, attachment.documentId].filter(Boolean).join(' | ');
  })
  .join('\n');

export const createEmptyCategoryDraft = () => ({
  id: null,
  name: '',
  slug: '',
  parent: '',
  description: '',
  icon: 'folder',
  displayOrder: 0,
  isActive: true,
});
